import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09df5d68"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-[#16161d] text-left" }, "Candidatos para o convite de troca", -1))
const _hoisted_2 = { class: "flex flex-col gap-4 text-left" }

import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import type { InviteResponseV2 } from '@/Network/Types/Responses/HandoverInviteResponses'
import CandidatesList from './CandidatesList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CandidatesModal',
  props: {
    modelValue: { type: Boolean },
    invites: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": _ctx.modelValue,
    "max-width": "max-w-[678px]",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(CandidatesList, { invites: _ctx.invites }, null, 8, ["invites"]),
        _createVNode(FilledButton, {
          text: "Fechar",
          width: "100%",
          height: "48px",
          class: "bg-primary30",
          "data-testid": "candidates-modal-close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
        })
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})